import type { ReactNode } from 'react';

import type { TContactFormElement } from '@shared/dream-components';
import { ContactFormElement } from '@shared/dream-components';

import ContactFormAction from '~/components/ContactFormAction';
import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import type { StaticPageLoaderData } from '~/services/static_page';

interface Props {
  node: TContactFormElement;
  children: ReactNode | ReactNode[];
}

const ContactForm = ({ node, children }: Props) => {
  const { page } = useTypedLoaderData<StaticPageLoaderData>();

  const fieldLabels = node.attrs?.data?.additional_fields?.reduce<Record<string, string>>((acc, field) => {
    acc[field.name_override || field.id] = field.name;
    return acc;
  }, {});

  return (
    <ContactFormAction
      id={node.attrs.id || ''}
      pageId={page.id}
      name={node.attrs?.formName}
      webhookUrl={node.attrs?.webhookUrl}
      fieldLabels={fieldLabels}
    >
      {({ isLoading }) => (
        <ContactFormElement element={node} isLive isLoading={isLoading}>
          {children}
        </ContactFormElement>
      )}
    </ContactFormAction>
  );
};

export default ContactForm;
